import { createElement } from 'react';
import cn from 'classnames';
import styles from './styles.scss';
import { LoaderProps, isLoading } from './index';

interface OwnProps extends LoaderProps {
  tag?: keyof React.ReactHTML;
}

export default ({ tag, loading, style, className, children }: OwnProps) =>
  createElement(
    tag || 'span',
    {
      style: isLoading(loading) ? style : {},
      className: cn(
        styles.text,
        {
          [styles.loading]: isLoading(loading)
        },
        className
      )
    },
    children
  );
